import { Box, Center, Loader } from '@mantine/core'
import { ProgramLayout } from '@ospace/layout'
import { ErrorBoundary } from '@ospace/shared'
import { useParams } from 'react-router-dom'

import { LeadExport } from '../../components/LeadExport'
import { useCampaign } from '../../hooks'
import { CampaignLayout } from './CampaignLayout'

type Props = { campaignId: number }
export const LeadExportPage = (props: Props) => {
  const { data: campaign, isFetching } = useCampaign(props.campaignId)

  if (isFetching) {
    return (
      <CampaignLayout>
        <Center style={{ minHeight: '100vh' }} h='100vh' mx='auto'>
          <Loader variant='bars' />
        </Center>
      </CampaignLayout>
    )
  }
  if (!campaign) {
    return (
      <CampaignLayout>
        <Box mt='md'>Campaign not found</Box>
      </CampaignLayout>
    )
  }

  return (
    <ProgramLayout status={'ready'} pageId='programs' fluid={true}>
      <Box mt='md'>
        <LeadExport campaign={campaign} />
      </Box>
    </ProgramLayout>
  )
}

const Controller = () => {
  const params: any = useParams()
  const campaignId = Number(params?.id)

  return <LeadExportPage campaignId={campaignId} />
}

export const LeadExportPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
